import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, unref as _unref, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["for"]
const _hoisted_2 = ["id", "type", "placeholder", "value", "disabled"]
const _hoisted_3 = {
  key: 1,
  class: "row gap-1 error-message"
}
const _hoisted_4 = { class: "body xs font-regular" }

import AppIcon from '@/components/common/app-icon/AppIcon.vue';
import CustomTooltip from '@/components/common/tooltip/CustomTooltip.vue';
import { InputType } from '@/models/input-type';
import { computed, ref, watch } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'TextField',
  props: {
    label: {},
    placeHolder: {},
    placeholder: {},
    modelValue: {},
    required: { type: Boolean },
    error: { type: Boolean },
    errorMessage: {},
    additionalInfo: {},
    disabled: { type: Boolean },
    type: {},
    id: {}
  },
  emits: ['update:modelValue'],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;
const internalValue = ref(props.modelValue ?? '');
const inputType = props.type ?? InputType.Text;
const uniqueId = `text-field-${Math.random().toString(36).substring(2, 9)}`;
const fieldId = computed(() => props.id || uniqueId);

const placeholderText = computed(
  () => props.placeholder ?? props.placeHolder ?? ''
);

function updateValue(e: Event) {
  const t = e.target as HTMLInputElement;
  internalValue.value = t.value;
  emit('update:modelValue', internalValue.value);
}

watch(
  () => props.modelValue,
  (v) => {
    internalValue.value = v ?? '';
  }
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["column gap-1 input-wrapper", { disabled: _ctx.disabled }])
  }, [
    (_ctx.label)
      ? (_openBlock(), _createElementBlock("label", {
          key: 0,
          class: "body xs font-regular row gap-1 align-center input-label",
          for: fieldId.value
        }, [
          _createTextVNode(_toDisplayString(_ctx.label) + " ", 1),
          (_ctx.additionalInfo)
            ? (_openBlock(), _createBlock(CustomTooltip, {
                key: 0,
                message: _ctx.additionalInfo
              }, {
                default: _withCtx(() => [
                  _createVNode(AppIcon, {
                    name: "info",
                    size: "body-s",
                    class: "additional-info"
                  })
                ]),
                _: 1
              }, 8, ["message"]))
            : _createCommentVNode("", true)
        ], 8, _hoisted_1))
      : _createCommentVNode("", true),
    _createElementVNode("input", {
      id: fieldId.value,
      type: _unref(inputType),
      class: "input-field",
      placeholder: placeholderText.value,
      value: internalValue.value,
      onInput: updateValue,
      disabled: _ctx.disabled
    }, null, 40, _hoisted_2),
    (_ctx.error && _ctx.errorMessage)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createVNode(AppIcon, {
            name: "info",
            size: "body-s"
          }),
          _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.errorMessage), 1)
        ]))
      : _createCommentVNode("", true)
  ], 2))
}
}

})